/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Tier_Pro_DescInputs */

const en_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI actions per month, full analytics, salary negotiation coaching.`)
};

const de_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 KI-Aktionen pro Monat, vollständige Analysen, Gehaltsverhandlungs-Coaching.`)
};

const fr_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 actions IA par mois, analyses complètes, coaching de négociation salariale.`)
};

const es_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 acciones IA al mes, análisis completos, orientación en negociación salarial.`)
};

const it_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 azioni AI al mese, analisi complete, coaching per la negoziazione salariale.`)
};

const nl_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI-acties per maand, volledige analyses, salarisonderhandelingscoaching.`)
};

const pl_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 akcji AI miesięcznie, pełna analityka, coaching negocjacji wynagrodzenia.`)
};

const fi_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI-toimintoa kuukaudessa, täysi analytiikka, palkkaneuvotteluvalmennus.`)
};

const da_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI-handlinger per måned, fulde analyser, lønforhandlingscoaching.`)
};

const sv_agb_tier_pro_desc = /** @type {(inputs: Agb_Tier_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 AI-åtgärder per månad, fullständig analys, löneförhandlingscoachning.`)
};

/**
* | output |
* | --- |
* | "300 AI actions per month, full analytics, salary negotiation coaching." |
*
* @param {Agb_Tier_Pro_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_tier_pro_desc = /** @type {((inputs?: Agb_Tier_Pro_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Tier_Pro_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_tier_pro_desc(inputs)
	if (locale === "fr") return fr_agb_tier_pro_desc(inputs)
	if (locale === "es") return es_agb_tier_pro_desc(inputs)
	if (locale === "it") return it_agb_tier_pro_desc(inputs)
	if (locale === "nl") return nl_agb_tier_pro_desc(inputs)
	if (locale === "pl") return pl_agb_tier_pro_desc(inputs)
	if (locale === "fi") return fi_agb_tier_pro_desc(inputs)
	if (locale === "da") return da_agb_tier_pro_desc(inputs)
	if (locale === "sv") return sv_agb_tier_pro_desc(inputs)
	return en_agb_tier_pro_desc(inputs)
});